import axios from '@/bootstrap'
const endpoint = 'annualized-turns-history'

export default class AnnualizedTurnsHistoryService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }
}
